module.exports = __webpack_public_path__ + "img/wxcess.e88ece35.png";